import axiosClient from '../api/AxiosConfig';

export const ProvinceService = {
  GetProvinces: async () => (await axiosClient.get('/province')).data,
};
